import { render, staticRenderFns } from "./asider.vue?vue&type=template&id=f8151f04&scoped=true&"
import script from "./asider.vue?vue&type=script&lang=js&"
export * from "./asider.vue?vue&type=script&lang=js&"
import style0 from "./asider.vue?vue&type=style&index=0&id=f8151f04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8151f04",
  null
  
)

export default component.exports